import axios from 'axios';

const apiCall = axios.create({
  baseURL: window.FlowSignOnlyWebsiteGlobalConfig.basePaths.flowController,
})

export default apiCall;
